import script from "./WikiPlayCta.vue?vue&type=script&setup=true&lang=ts"
export * from "./WikiPlayCta.vue?vue&type=script&setup=true&lang=ts"

import "./WikiPlayCta.vue?vue&type=style&index=0&id=560a4354&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560a4354"]])

export default __exports__